
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rising-star",
      function () {
        return require("private-next-pages/rising-star/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rising-star"])
      });
    }
  